import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Label,
} from '@playcastdotio/Shadcn';
import { Content } from './Content';
import { useState } from 'react';

export const Account = ({
  email,
  onEditEmail,
  phoneNumber,
  onEditPhoneNumber,
}: {
  email: string;
  onEditEmail: (newEmail: string) => void;
  phoneNumber: string;
  onEditPhoneNumber: (newNumber: string) => void;
}) => {
  const [editingEmail, setEditingEmail] = useState(false);
  const [editingPhoneNumber, setEditingPhoneNumber] = useState(false);
  const [emailValue, setEmailValue] = useState(email);
  const [phoneNumberValue, setPhoneNumberValue] = useState(phoneNumber);
  const [showConfirmDialog, setConfirmDialog] = useState(false);

  const handleDeleteAccountClicked = () => {
    setConfirmDialog(false);
    // send an email to trey@playcast.io with the subject line "Deletion Request"
    window.open('mailto:trey@playcast.io?subject=Deletion Request', '_blank');
  };
  const handleEmailButtonClicked = () => {
    if (editingEmail) {
      onEditEmail(emailValue);
    }
    setEditingEmail(!editingEmail);
  };
  const handlePhoneButtonClicked = () => {
    if (editingPhoneNumber) {
      onEditPhoneNumber(phoneNumberValue);
    }
    setEditingPhoneNumber(!editingPhoneNumber);
  };

  return (
    <Content title='Account'>
      <div className='flex h-full flex-1 flex-col space-y-4'>
        <div className='flex md:gap-x-4'>
          <div className='flex w-0 flex-1 flex-col'>
            <Label className='font-[Syne] text-gray-400'>Email</Label>
            {editingEmail ? (
              <input
                className='rounded-md bg-gray-800 p-1 text-xl text-white'
                value={emailValue}
                onChange={(e) => setEmailValue(e.target.value)}
              />
            ) : (
              <span className='truncate text-xl text-white'>{emailValue ? emailValue : 'No Email'}</span>
            )}
          </div>
          {/* <Button className='m-0 ml-auto px-10 py-1 h-fit w-fit mt-auto' onClick={handleEmailButtonClicked}>
            {editingEmail ? 'Save' : 'Edit'}
          </Button> */}
        </div>
        <div className='flex md:gap-x-4'>
          <div className='mt-2 flex w-0 flex-1 flex-col'>
            <Label className='font-[Syne] text-gray-400'>Phone Number</Label>
            {editingPhoneNumber ? (
              <input
                className='rounded-md bg-gray-800 p-1 text-xl text-white'
                value={phoneNumberValue}
                onChange={(e) => setPhoneNumberValue(e.target.value)}
              />
            ) : (
              <span className='truncate text-xl text-white'>{phoneNumberValue ? phoneNumberValue : 'No Phone Number'}</span>
            )}
          </div>
          {/* <Button className='m-0 ml-auto px-10 py-1 h-fit w-fit mt-auto' onClick={handlePhoneButtonClicked}>
            {editingPhoneNumber ? 'Save' : 'Edit'}
          </Button> */}
        </div>
        <div className='flex flex-1'>
          <div className='mt-auto flex flex-col'>
            <Label className='font-[Syne] text-gray-400'>Remove Account</Label>
            <Dialog open={showConfirmDialog}>
              <DialogTrigger asChild>
                <Button className='m-0 ml-auto mt-2 h-fit w-fit px-10 py-1' variant='outline' onClick={() => setConfirmDialog(true)}>
                  Delete Account
                </Button>
              </DialogTrigger>
              <DialogContent className='text-white'>
                <DialogHeader>
                  <DialogTitle>Are you sure?</DialogTitle>
                  <DialogDescription>
                    By deleting your account, you will lose all of your data and will not be able to recover it.
                  </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                  <Button
                    type='submit'
                    className='bg-gray-400 hover:bg-gray-600 focus:bg-gray-400 active:bg-gray-600'
                    onClick={() => setConfirmDialog(false)}
                  >
                    Cancel
                  </Button>
                  <Button type='submit' variant='outline' onClick={handleDeleteAccountClicked}>
                    Confirm
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          </div>
        </div>
      </div>
    </Content>
  );
};

